import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({ name: 'dateFormat' })
export class DateFormatPipe implements PipeTransform {
    transform(value: Date | moment.Moment, dateFormat: string): any {
        if (!value) {
            return '';
        }
        const m = moment(value);
        if (!m.isValid()) {
            return '';
        }
        return m.format(dateFormat);
    }
}